(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.EditCompanyPagesController = (function(superClass) {
    extend(EditCompanyPagesController, superClass);

    function EditCompanyPagesController(scope, transitions, modalInstance, service, company, pages, reports) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.company = company;
      this.save = bind(this.save, this);
      this.toggleEnabled = bind(this.toggleEnabled, this);
      EditCompanyPagesController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.absolute_errors = true;
      this.scope.title = "Edit " + this.company.name + " Portal Pages and Reports";
      this.scope.pages = pages.data;
      this.scope.reports = reports.data;
      this.scope.toggleEnabled = this.toggleEnabled;
    }

    EditCompanyPagesController.prototype.toggleEnabled = function(item) {
      return item.enabled = !item.enabled;
    };

    EditCompanyPagesController.prototype.save = function() {
      return this.service.saveCompanyPagesAndReports(this.company.id, this.scope.pages, this.scope.reports).then((function(_this) {
        return function(response) {
          return _this.closeWithAlert(response.data.status);
        };
      })(this));
    };

    return EditCompanyPagesController;

  })(DialogController);

}).call(this);
